import { render, staticRenderFns } from "./EditLocationDetails.vue?vue&type=template&id=670da7b6&scoped=true"
import script from "./EditLocationDetails.vue?vue&type=script&lang=js"
export * from "./EditLocationDetails.vue?vue&type=script&lang=js"
import style0 from "./EditLocationDetails.vue?vue&type=style&index=0&id=670da7b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670da7b6",
  null
  
)

export default component.exports